import MESSAGES from 'core/data-model/constants/bi-messages'
import CONSTANTS from 'core/data-model/constants/messages'
import { checkWaiveAnnualBasicPremiumForReplaceWording } from 'core/service/basic-plan/basic-plan'
import { dashedOutOrWithPrecision } from './policy-value-row'

const PolicyTable = ({ className, children }) => (
  <table className={`policy-table${className ? ` ${className}` : ''}`} id="policy-value-table">
    {children}
  </table>
)

export const PolicyValueRowLifeProtectPlus = ({
  age,
  yearEndPolicy,
  cumulativeBasicPremium,
  annualBasicPremium,
  surrenderCash,
  deathBenefit,
  basicSumAssured,
  boostBenefit
}) => {
  return (
    <tr id={`policy-value-row-${age.value}`}>
      <td className="policy-value-age">{age.value}</td>
      <td className="policy-value-year">{yearEndPolicy}</td>
      <td className="policy-value-annual-basic-premium">{dashedOutOrWithPrecision(annualBasicPremium, 2)}</td>
      <td className="policy-value-cumulative-basic-premium">{dashedOutOrWithPrecision(cumulativeBasicPremium, 2)}</td>
      <td className="policy-value-sum-assured">{dashedOutOrWithPrecision(basicSumAssured, 2)}</td>
      {/* booster fix here */}
      <td className="policy-value-booster-coverage">{dashedOutOrWithPrecision(boostBenefit, 2)}</td>
      <td className="policy-value-death-benefit">{dashedOutOrWithPrecision(deathBenefit, 2)}</td>
      <td className="policy-value-surrender-cash">{dashedOutOrWithPrecision(surrenderCash, 2)}</td>
    </tr>
  )
}

export const PolicyLifeProtectPlus = ({
  yearEndPolicyValues,
  lastYearEndPolicy,
  subtotalAnnualBasicPremium,
  basicPlan,
}) => (
  <PolicyTable className="with-cash-drop with-cash-drop-basic-premium">
    <thead>
      <tr>
        <td width="5%" rowSpan={2}>
          {CONSTANTS.AGE}
        </td>
        <td className="nowrap" width="5%" rowSpan={2}>
          {MESSAGES.POLICY_YEAR}
        </td>
        <td width="15%" colSpan={2}>
          {MESSAGES.BASIC_PREMIUM}
        </td>
        <td width="8%" rowSpan={2}>
          {MESSAGES.SUM_ASSURED_1}<br />{MESSAGES.SUM_ASSURED_2}*
        </td>
        <td width="7%" rowSpan={2}>
          {MESSAGES.BOOSTER_COVERAGE_1}<br />{MESSAGES.BOOSTER_COVERAGE_2}**
        </td>
        <td width="10%" rowSpan={2}>
          {MESSAGES.DEATH_COVERAGE_1}<br />{MESSAGES.DEATH_COVERAGE_2}***
        </td>
        <td width="10%" rowSpan={2}>
          {MESSAGES.SURRENDER_VALUE_END_OF_YEAR}
        </td>
      </tr>
      <tr>
        <td width="10%">{MESSAGES.PER_YEAR}</td>
        <td width="10%">{MESSAGES.CUMULATIVE}</td>
      </tr>
    </thead>
    <tbody>
      {yearEndPolicyValues.map((policyValue) => {
        return (
          <PolicyValueRowLifeProtectPlus
            id="policy-value-row"
            key={`policy-value-row-${policyValue.age.value}`}
            age={policyValue.age}
            yearEndPolicy={policyValue.yearEndPolicy}
            cumulativeBasicPremium={policyValue.cumulativeBasicPremium}
            annualBasicPremium={checkWaiveAnnualBasicPremiumForReplaceWording(policyValue, basicPlan)}
            annualRiderPremium={policyValue.annualRiderPremium}
            annualTotalPremium={policyValue.annualTotalPremium}
            surrenderCash={policyValue.surrenderCash}
            boostBenefit={policyValue.boostBenefit}
            deathBenefit={policyValue.deathBenefit}
            basicSumAssured={policyValue.basicSumAssured}
          />
        )
      })}
      <tr className="total" id={`policy-value-row-${lastYearEndPolicy}`} key={`policy-value-row-${lastYearEndPolicy}`}>
        <td />
        <td />
        <td>{dashedOutOrWithPrecision(subtotalAnnualBasicPremium, 2)}</td>
        <td />
        <td />
        <td />
        <td />
        <td />
      </tr>
    </tbody>
  </PolicyTable>
)
